import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Layouts } from '../../app.component';
import {FeatureViewComponent} from "./feature-view.component";

const routes: Routes = [  {
    path : 'data-catalogue/feature/:id',
    component : FeatureViewComponent,
    data: { layout: Layouts.SecureLayout }
}
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class FeatureViewRoutingModule { }